/*
  说明: 将各个模块合并成一个状态实例
  导入: 各个模块
  导出: 应用的状态管理实例
*/

import Vue from 'vue'
import Vuex from 'vuex'
import {
  getItem,
  setItem,
  removeItem,
  setLocalItem,
  timeFormat,
  dateToTime,
  getTermOrder,
  timeStrToDate
} from '@/utils/comUtils'
import { LEAVE_ROLE } from '@/utils/constUtils'
import API from '@/api'

import moduleRole from './role'
import expireSku from './modules/expireSku' // 套餐期通知
import security from './modules/security' // 套餐期通知
Vue.use(Vuex)

const MORAL_TIME_PICKER_TYPE = 'MORAL_TIME_PICKER_TYPE'

export default new Vuex.Store({
  state: {
    token: null,
    functinList: [],
    currentRole: null,
    tags: null,
    currentTagId: '',
    currentTagIdOld: '',
    saveGroupMemberOld: null,
    saveGroupDeptsOld: null,
    currentCapmus: null,
    condition: null,
    campusList: null,
    studentList: null,
    classCampus: null,
    studentDetail: null,
    studentDetailCopy: null,
    currentTabId: null,
    selectedClass: null,
    attendanceGroup: {
      attendanceGroupName: null,
      memberCount: 0,
      members: null,
      depts: null,
      timeSettingDtoList: null,
      attendanceDays: null,
      attendanceDeviceIds: null,
      guardianAttendance: null,
      noNeedCheckOut: null,
      noNeedCheckIn: null
    },
    addressModifyMember: false,
    attendanceGroupId: null,
    initFactor: null,
    attendanceMain: {
      date: null, // 日期
      depts: null, // 部门
      dept: null // 部门对象
    },
    creatGoToSchoolStage: null,
    creatGoToSchoolOneStage: null,
    studentInfo: null,
    studentNumber: null,
    calendarTime: null,
    teachInfo: null,
    headmasterId: null,
    monthTime: null,
    isCalendarForm: null,
    attendanceTimesList: [],
    attendanceDate: [],
    primaryDate: null,
    attendanceTip: true,
    expressModle: false,
    headmasterClass: [],
    defaultDateRange: {},
    settingNum: 0,
    saveTimeName: '', // 时段名称
    screenDetail: {
      preview: '', // 预览地址
      name: '', // 大屏名称
      screenId: '', // 大屏ScreenId
      viewId: '' // 投屏viewId
    },
    entranceDevice: {
      // 出入校考勤设备
      deviceIds: null,
      attendanceDays: null, // 考勤日期，1-7数字代表星期，8代表节假日考勤，例：12345678'
      weekDeployDtoList: null
    },
    noLimitFlag: true, // 到离校门禁不限制通行
    passCount: null, // 到离校门禁限制通行时的通行次数
    permitDevices: [], // 到离校门禁设备
    afterschoolHeaderMasterDevices: [], // 班主任刷脸设备
    commonConfigId: '', // 配置id
    conflictLeaveList: [], // 请假冲突记录
    leaveData: null, // 请假的发起记录
    leaveRecord: null,
    noticeDtoList: null, // 通知
    deviceParams: {}, // 设备参数
    inOutType: null, // 上下学类型
    hasFlexLeaveDevice: false, // 是否设置了弹性离校设备
    clockPeriods: null, // 打卡时段 考勤和宿管都可以使用
    dormState: null,
    dormDetailState: null,
    loadFromStore: false, // 是否从内存加载考勤组详情
    isFromBack: 0, // 是否回退 1-回退 2-高亮提示
    checkAttencer: false, // 是否检查参与考勤人员重复
    attendanceMemberType: null, // 参与考勤人员类型
    specialAttendanceDays: null, // 特殊日期考勤集合
    specialNoAttendanceDays: null, // 不用打卡日期
    holidaysAttendance: true, // 法定节假日是否考勤
    sandboxId: '',
    orgSandboxId: '',
    isSandboxCreated: false,
    isSandboxPrepared: false,
    isSandboxComplete: false,
    currentAuditStatus: 0,
    weekNow: -1,
    weekList: [],
    moralTimeType: 1, // // 1: 周 2: 学期
    isClassTeacher: null,
    isMeTeacher: null,
    isCETeacher: null,
    isUseFaceInput: false,
    retryTimes: 0, // 错误重试次数
    classMoralClass: null,
    classcardDetail: { id: 0 },
    qingtianDeviceDetail: {},
    classcardSource: 0,
    classDing: {},
    skuInfo: null, // 模块信息
    studentHornor: null, // 学生荣誉
    termSetting: null, // 学年学期信息

    attendanceQueryFilter: null, // 考勤筛选条件
    addressParentNodeLists: null, // 部门节点缓存
    attendanceSelectDetailNodes: null, // 考勤通讯录选中的节点集合
    gradeList: [], // 所有年级列表
    attendanceClassList: [], // 当前的班级列表
    saveCycle: 30, // 数据看板默认时间
    pageList: null, // 浏览页面
    classEvaluationTab: 0, // 课堂评价tab
    classEvaluationDingId: '', // 课堂评价 老师的dingUserId
    isCustomNotification: null,
    cachedViews: [], // 界面缓存对象
    semesterList: [],
    semesterSetting: {
      schoolYear: '',
      termEndDimDay: '',
      termOrder: '',
      termStartDimDay: '',
      showTermDialog: false,
      beforeYearEndDate: '',
      canBeUpgraded: false
    },
    pageIsUpgraded: '', // 是否已升级
    dateNow: '',
    platformSource: 0, // 2、7 魔方
    isCampusHeadmaster: null, // 是否是校区的班主任
    isScheduleTeacher: null, // 是否为滞留生的值周老师
    classcardTemplate: null, // 班牌设备主题ID
    dishSegmentList: [], // 每日食谱时段
    dishDetail: {
      mealVos: []
    },
    selectedDish: {},
    dishFilter: null,
    isEditDish: 0,
    mealType: -1,
    dashActiveIndex: -1,
    dishModifyType: 0,
    commonDishesClassifyObj: {},
    activeTabIndex: 1,
    cacheObject: null,
    applicationStatus: null,
    reasonType: null,
    moralTimePickerMap: getItem(MORAL_TIME_PICKER_TYPE) || {
      dateStr: '',
      activeValue: {},
      activeIndex: []
    },
    selfDepts: null,
    allowLeaveBackCertificate: 0, // 请假返校开关
    classCardModeCache: {},
    ...moduleRole.state,
    history: [
      {
        id: 0,
        title: '魔点校园',
        deptId: 0,
        deptName: '魔点校园'
      }
    ],
    faceSandBoxId: null,
    studentSandBoxId: null,
    guardianSandBoxId: null,
    // 设备管理类型
    deviceManageType: null,
    // 请假类型
    leaveTypeObj: {},
    leaveStatisticsDate: timeFormat(new Date(), 'YYYY/MM/DD'),

    deviceModel: null,
    customTemplateCampusId: '',
    customTemplateInfo: null,
    customDeviceName: '',
    classicTemplateInfo: null, // 经典班牌模式 保存的模板信息
    classicModeSelectedClass: null,
    customPadTemplateId: '',
    attendanceSpanHour: 0,
    routeForTabbar: [],
    unExpireNum: 0,
    vehicleApiVersion: null,
    vehicleVersionUpdatedAt: 0,
    tabbarShow: true,
    behaviorDate: {
      dateStr: '',
      activeValue: {},
      activeIndex: []
    },
    behaviorDateRange: {
      dateStr: '',
      activeValue: {},
      activeIndex: []
    },
    behaviorClass: {
      gradeDingId: '',
      gradeName: '',
      classDingId: '',
      className: ''
    },
    noticeRoleList: [],
    parklotInfo: null, // 车场信息
    leaveEditFlag: false,
    // 学生签到：列表页选中的班级卡片数据
    signInClassItem: {},
    orderInfo: {
      orderId: '',
      formHtml: '',
      timeOutMinutes: 15,
      orderPay: 0
    }
  },
  getters: {
    ...moduleRole.getters,
    parklotInfo(state) {
      return state.parklotInfo
    },
    leaveEditFlag(state) {
      return state.leaveEditFlag
    },
    getOverviewRoleTabs(state) {
      // 数据总览只有管理员、班主任、区域负责人有权限可看

      // 拥有全部班级角色权限
      const totalClassRoleIdList = [
        LEAVE_ROLE.admin,
        LEAVE_ROLE.securityManager
      ]
      let isTotalCalss = state.roleIdList.filter(v =>
        totalClassRoleIdList.includes(v)
      )

      const myClassRoleIdList = [LEAVE_ROLE.headmaster]
      let isMyClass = state.roleIdList.filter(v =>
        myClassRoleIdList.includes(v)
      )

      const tabs = []
      if (isTotalCalss.length) {
        tabs.push({
          name: '全部班级',
          id: '1',
          roles: isTotalCalss
        })
      }

      if (isMyClass.length) {
        tabs.push({
          name: '我的班级',
          id: '2',
          roles: isMyClass
        })
      }
      return tabs
    },
    // 校园安全专用
    roleTabs(state) {
      // 拥有全部班级角色权限
      const totalClassRoleIdList = [
        LEAVE_ROLE.admin,
        LEAVE_ROLE.securityPolicer,
        LEAVE_ROLE.securityManager
      ]
      let isTotalCalss = state.roleIdList.filter(v =>
        totalClassRoleIdList.includes(v)
      )

      const myClassRoleIdList = [LEAVE_ROLE.headmaster]
      let isMyClass = state.roleIdList.filter(v =>
        myClassRoleIdList.includes(v)
      )

      const tabs = []
      if (isTotalCalss.length) {
        tabs.push({
          name: '全部班级',
          id: '1',
          roles: isTotalCalss
        })
      }

      if (isMyClass.length) {
        tabs.push({
          name: '我的班级',
          id: '2',
          roles: isMyClass
        })
      }
      return tabs
    },
    unExpireNum(state) {
      return state.unExpireNum
    },
    customPadTemplateId(state) {
      return state.customPadTemplateId
    },
    classicModeSelectedClass(state) {
      return state.classicModeSelectedClass
    },
    classicTemplateInfo(state) {
      return state.classicTemplateInfo
    },
    deviceModel(state) {
      return state.deviceModel
    },
    customTemplateCampusId(state) {
      return state.customTemplateCampusId
    },
    customTemplateInfo(state) {
      return state.customTemplateInfo
    },
    customDeviceName(state) {
      return state.customDeviceName
    },

    studentSandBoxId(state) {
      return state.studentSandBoxId
    },
    guardianSandBoxId(state) {
      return state.guardianSandBoxId
    },
    faceSandBoxId(state) {
      return state.faceSandBoxId
    },
    history(state) {
      return state.history
    },
    activeTabIndex(state) {
      return state.activeTabIndex
    },
    cacheObject(state) {
      return state.cacheObject
    },
    applicationStatus(state) {
      return state.applicationStatus
    },
    reasonType(state) {
      return state.reasonType
    },
    dateNow(state) {
      return state.dateNow
    },
    pageIsUpgraded(state) {
      return state.pageIsUpgraded
    },
    semesterSetting(state) {
      if (!state.semesterSetting) {
        state.semesterSetting = getItem('semesterSetting')
      }
      return state.semesterSetting
    },
    semesterList(state) {
      return state.semesterList
    },
    semesterOptions(state) {
      const options = state.semesterList.filter(
        item => item.schoolTermStartDimDay && item.schoolTermEndDimDay
      )
      const current = timeFormat(new Date(), 'YYYYMMDD')
      if (options.length === 2) {
        // 存在两个学期信息 如果开始日期小于第一学期的结束时间 就只能看到第一学期 大于定义学期的结束时间 就可以看到两个学期
        const { schoolTermEndDimDay } = options[0]
        return options.slice(0, schoolTermEndDimDay >= current ? 1 : 2)
      }
      return options
    },
    isCustomNotification(state) {
      return state.isCustomNotification
    },
    attendanceClassList(state) {
      return state.attendanceClassList
    },
    selfDepts(state) {
      return state.selfDepts
    },
    allowLeaveBackCertificate(state) {
      return state.allowLeaveBackCertificate
    },
    isWholeSchool(state) {
      // 选中的节点
      let data = state.attendanceSelectDetailNodes || []
      // 什么都没选并且筛选条件存在  就是全校
      if (!data.length && state.attendanceQueryFilter) {
        return true
      }
      // return false
      // 所有的父级节点
      let total = state.addressParentNodeLists || null

      // 所有的父级节点都没有展开
      if (!total || !total.length) {
        return false
      }

      let singleNodes = []
      data.map(v => {
        singleNodes.push(v.deptId)
      })

      for (let index = 0; index < total.length; index++) {
        const deptId = total[index].deptId
        // 只要有一个不符合全校的条件
        if (!singleNodes.includes(deptId)) {
          return false
        }
      }
      return true
    },
    storeGettersFilterText(state, getters) {
      let map = state.attendanceQueryFilter
      let selectedNode = state.attendanceSelectDetailNodes || []
      if (!map) {
        return ''
      }
      let departMentText = ''
      if (getters.curIsAdmin) {
        if (getters.isWholeSchool || !selectedNode.length) {
          departMentText = '全校、'
        } else {
          departMentText = selectedNode.length + '个部门、'
        }
      }
      let attendanceGroupName =
        (map.group && map.group.attendanceGroupName) || ''
      if (attendanceGroupName.length > 13) {
        attendanceGroupName = attendanceGroupName.slice(0, 13) + '···'
      }
      let finallyText = `筛选条件：${departMentText}${
        attendanceGroupName ? attendanceGroupName + '、' : ''
      }${
        map.timePeriod && map.timePeriod.schoolTime
          ? map.timePeriod.schoolTime + ' ~ ' + map.timePeriod.homeTime
          : ''
      }`
      // 如果自定义通知，需要回显日期
      if (getters.isCustomNotification && map.dimDay) {
        finallyText += '、' + dateToTime(map.dimDay, '-')
      }
      if (finallyText && finallyText.length && finallyText.length > 48) {
        finallyText = finallyText.slice(0, 48) + '···'
      }
      return finallyText
    },
    gradeList(state) {
      return state.gradeList
    },
    // 获取机构用户id
    orgUserId(state) {
      let _orgUserId = (state.token || {}).orgUserId
      if (!_orgUserId) {
        _orgUserId = (getItem('TOKEN') || {}).orgUserId
      }
      return _orgUserId
    },
    // 获取标签
    tags(state) {
      return state.tags
    },
    // 获取当前标签
    currentTagId(state) {
      return state.currentTagId
    },
    currentTagIdOld(state) {
      return state.currentTagIdOld
    },
    // 获取学校信息
    schoolInfo(state) {
      let _schoolInfo = {}
      let _token = state.token
      if (!_token) {
        _token = getItem('TOKEN')
        state.token = _token
      }
      if (_token && _token.schoolInfo) {
        _schoolInfo = _token.schoolInfo
      }
      return _schoolInfo
    },
    // 班主任校区 + 班级
    classCampusAll(state) {
      let _token = state.token
      if (!_token) {
        _token = getItem('TOKEN')
        state.token = _token
      }
      if (_token && _token.schoolInfo && _token.schoolInfo.isHeadmaster) {
        state.classCampus = _token.schoolInfo.headmasterClass
      }
      return state.classCampus
    },

    // 学生信息(仅限学生)
    studentDetail(state) {
      if (state.studentDetail || state.studentDetailCopy) {
        return state.studentDetail || state.studentDetailCopy
      }
      let _token = state.token
      if (!_token) {
        _token = getItem('TOKEN')
        state.token = _token
      }
      state.studentDetail =
        (_token &&
          _token.schoolInfo &&
          _token.schoolInfo.studentClass &&
          _token.schoolInfo.studentClass[0] &&
          _token.schoolInfo.studentClass[0].schoolClassDtoList &&
          _token.schoolInfo.studentClass[0].schoolClassDtoList.length &&
          _token.schoolInfo.studentClass[0].schoolClassDtoList[0]) ||
        null
      return state.studentDetail
    },
    // 请假历史过滤条件
    filterCondition(state) {
      return state.condition || null
    },
    filterDimension(state) {
      return state.condition
        ? state.condition[state.condition.length - 1].dimension
        : '0'
    },
    selectedStudent(state) {
      return state.selectedStudent || null
    },
    // 获取选取班级
    selectedClass(state) {
      return state.selectedClass || null
    },
    // 考勤组名字
    saveGroupName(state) {
      return state.attendanceGroup.attendanceGroupName
    },
    // 考勤日期
    attendanceDays(state) {
      return state.attendanceGroup.attendanceDays
    },
    // 上下学时间段
    saveGroupDtoList(state) {
      return state.attendanceGroup.timeSettingDtoList
    },
    // 成员id
    saveGroupMember(state) {
      return state.attendanceGroup.members
    },
    // 已选人员
    memberCount(state) {
      return state.attendanceGroup.memberCount
    },
    // 成员id
    saveGroupMemberOld(state, saveGroupMemberOld) {
      return state.saveGroupMemberOld
    },
    // 保存上下学时间段
    saveGroupDepts(state) {
      return state.attendanceGroup.depts
    },
    saveGroupDeptsOld(state) {
      return state.saveGroupDeptsOld
    },
    // 保存设备IdattendanceDeviceIds
    saveGroupDeviceIds(state) {
      return state.attendanceGroup.attendanceDeviceIds
    },
    // 是否开启家长代考勤guardianAttendance
    saveGroupGuardian(state) {
      return state.attendanceGroup.guardianAttendance
    },
    // 是否开启上午不需要打卡
    saveGroupSchoolNotGoing(state) {
      return state.attendanceGroup.noNeedCheckIn
    },
    // 是否开启下午不需要打卡
    saveGroupNotGoing(state) {
      return state.attendanceGroup.noNeedCheckOut
    },
    // 考勤组id
    attendanceGroupId(state) {
      return state.attendanceGroupId
    },
    // 保存考勤组日打卡详情初始化条件
    initFactor(state) {
      return state.initFactor
    },
    // 学生考勤页面日期
    attendanceMainDate(state) {
      return state.attendanceMain.date
    },
    // 学生考勤页面部门
    attendanceMainDepts(state) {
      return state.attendanceMain.depts
    },
    // 学生考勤页面部门对象
    attendanceMainDept(state) {
      return state.attendanceMain.dept
    },
    // 创建上下学时段
    attendanceCreateStage(state) {
      return state.creatGoToSchoolStage
    },
    // 设置或保存单条上下学时间段
    attendanceCreateOneStage(state) {
      return state.creatGoToSchoolOneStage
    },
    // 保存学生信息
    studentInfo(state) {
      return state.studentInfo
    },
    // 保存家长选择孩子的序号
    studentNumber(state) {
      if (!state.studentNumber) {
        state.studentNumber = localStorage.getItem('studentNumber') || ''
      }
      return state.studentNumber
    },
    // 日期获取的时间
    calendarTime(state) {
      return state.calendarTime
    },
    // 获取老师班级信息
    teachInfo(state) {
      return state.teachInfo
    },
    // 存储用户Id
    headmasterId(state) {
      return state.headmasterId
    },
    // 月统计时间
    monthTime(state) {
      return state.monthTime
    },
    // 判断是月统计还是打卡日历
    isCalendarForm(state) {
      return state.isCalendarForm
    },
    // 设置考勤时段
    attendanceTimesList(state) {
      return state.attendanceTimesList
    },
    // 当前使用的日期
    attendanceDate(state) {
      return state.attendanceDate
    },
    // 预选时间
    primaryDate(state) {
      return state.primaryDate
    },
    // 学生考勤提示
    attendanceTip(state) {
      return state.attendanceTip
    },
    // 体验模式的title的显示隐藏
    expressModle(state) {
      return state.expressModle
    },
    // 班主任下面的班级
    headmasterClass(state) {
      return state.headmasterClass
    },
    // 待设置数目
    settingNum(state) {
      return state.settingNum
    },
    defaultDateRange(state) {
      return state.defaultDateRange
    },
    // 时段名称
    saveTimeName(state) {
      return state.saveTimeName
    },
    // 宿管设备可用考勤 entranceDevice
    saveEntranceDevice(state) {
      return state.entranceDevice
    },
    // 到离校门禁不限制通行
    noLimitFlag(state) {
      return state.noLimitFlag
    },
    // 到离校门禁限制通行时的通行次数
    passCount(state) {
      return state.passCount
    },
    // 到离校门禁设备
    permitDevices(state) {
      return state.permitDevices
    },
    // 班主任刷脸设备
    afterschoolHeaderMasterDevices(state) {
      return state.afterschoolHeaderMasterDevices
    },
    // 配置id
    commonConfigId(state) {
      return state.commonConfigId
    },
    conflictLeaveList(state) {
      return state.conflictLeaveList
    },
    // 请假数据
    leaveData(state) {
      return state.leaveData || getItem('leaveData')
    },
    // 修改或撤销请假记录信息
    leaveRecord(state) {
      return state.leaveRecord
    },
    noticeDtoList(state) {
      return state.noticeDtoList
    },
    // 保存的投屏
    screenDetail(state) {
      return state.screenDetail
    },
    deviceParams(state) {
      return state.deviceParams
    },
    // 上下学类型
    inOutType(state) {
      return state.inOutType
    },
    hasFlexLeaveDevice(state) {
      return state.hasFlexLeaveDevice
    },
    clockPeriods(state) {
      return state.clockPeriods
    },
    currentTabId(state) {
      return state.currentTabId
    },
    dormState(state) {
      return state.dormState
    },
    dormDetailState(state) {
      return state.dormDetailState
    },
    loadFromStore(state) {
      return state.loadFromStore
    },
    isFromBack(state) {
      return state.isFromBack
    },
    checkAttencer(state) {
      return state.checkAttencer
    },
    attendanceMemberType(state) {
      return state.attendanceMemberType
    },
    specialAttendanceDays(state) {
      return state.specialAttendanceDays
    },
    specialNoAttendanceDays(state) {
      return state.specialNoAttendanceDays
    },
    holidaysAttendance(state) {
      return state.holidaysAttendance
    },
    sandboxId(state) {
      return state.sandboxId
    },
    orgSandboxId(state) {
      return state.orgSandboxId
    },
    addressModifyMember(state) {
      return state.addressModifyMember
    },
    isSandboxPrepared(state) {
      return state.isSandboxPrepared
    },
    isSandboxCreated(state) {
      return state.isSandboxCreated
    },
    isSandboxComplete(state) {
      return state.isSandboxComplete
    },
    currentAuditStatus(state) {
      return state.currentAuditStatus
    },
    weekNow(state) {
      return state.weekNow
    },
    weekList(state) {
      return state.weekList
    },
    moralTimeType(state) {
      return state.moralTimeType
    },
    isUseFaceInput(state) {
      return state.isUseFaceInput
    },
    retryTimes(state) {
      return state.retryTimes
    },
    classMoralClass(state) {
      return state.classMoralClass
    },
    skuInfo(state) {
      let _sku = state.skuInfo
      if (!_sku) {
        _sku = getItem('sku')
        state.skuInfo = _sku
      }
      return _sku
    },
    classcardDetail(state) {
      return state.classcardDetail
    },
    qingtianDeviceDetail(state) {
      return state.qingtianDeviceDetail
    },
    classcardSource(state) {
      return state.classcardSource
    },
    classDing(state) {
      return state.classDing
    },
    studentHornor(state) {
      return state.studentHornor
    },
    termSetting(state) {
      return state.termSetting
    },
    attendanceQueryFilter(state) {
      return state.attendanceQueryFilter
    },
    attendanceSelectDetailNodes(state) {
      return state.attendanceSelectDetailNodes
    },
    saveCycle(state) {
      return state.saveCycle
    },
    pageList(state) {
      return state.pageList
    },
    cachedViews(state) {
      return state.cachedViews
    },
    classEvaluationTab(state) {
      return state.classEvaluationTab
    },
    classEvaluationDingId(state) {
      return state.classEvaluationDingId
    },
    platformSource(state) {
      return state.platformSource
    },
    mixCloudOrg(state) {
      let _token = state.token
      if (!_token) {
        _token = getItem('TOKEN')
        state.token = _token
      }
      return _token.mixCloudOrg
    },
    classcardTemplate(state) {
      return state.classcardTemplate
    },
    dishSegmentList(state) {
      return state.dishSegmentList
    },
    dishDetail(state) {
      return state.dishDetail
    },
    selectedDish(state) {
      return state.selectedDish
    },
    dishFilter(state) {
      return state.dishFilter
    },
    isEditDish(state) {
      return state.isEditDish
    },
    mealType(state) {
      return state.mealType
    },
    dashActiveIndex(state) {
      return state.dashActiveIndex
    },
    dishModifyType(state) {
      return state.dishModifyType
    },
    commonDishesClassifyObj(state) {
      return state.commonDishesClassifyObj
    },
    classCardModeCache(state) {
      return state.classCardModeCache
    },
    leaveTypeObj(state) {
      return state.leaveTypeObj
    },
    leaveStatisticsDate(state) {
      return state.leaveStatisticsDate
    },
    routeForTabbar(state) {
      return state.routeForTabbar
    },
    behaviorDate(state) {
      return state.behaviorDate
    },
    behaviorDateRange(state) {
      return state.behaviorDateRange
    },
    behaviorClass(state) {
      return state.behaviorClass
    },
    noticeRoleList(state) {
      return state.noticeRoleList
    },
    // 学生签到：获取选中的班级卡片
    signInClassItem(state) {
      return state.signInClassItem
    },
    orderInfo(state) {
      return state.orderInfo
    }
  },
  mutations: {
    ...moduleRole.mutations,
    setFunctinList(state, list) {
      state.functinList = list
    },
    setParklotInfo(state, data) {
      state.parklotInfo = data
    },
    setLeaveEditFlag(state, data) {
      state.leaveEditFlag = data
    },
    handlerTabbarShow(state, data) {
      state.tabbarShow = data
    },
    setUnExpireNum(state, data) {
      state.unExpireNum = data
    },
    setCustomPadTemplateId(state, data) {
      state.customPadTemplateId = data
    },
    setClassicTemplateInfo(state, data) {
      state.classicTemplateInfo = data
    },
    setClassicModeSelectedClass(state, data) {
      state.classicModeSelectedClass = data
    },
    setDeviceModel(state, data) {
      state.deviceModel = data
    },
    setCustomTemplateCampusId(state, data) {
      state.customTemplateCampusId = data
    },
    setCustomTemplateInfo(state, data) {
      state.customTemplateInfo = data
    },
    setCustomDeviceName(state, data) {
      state.customDeviceName = data
    },

    setHistory(state, data) {
      state.history = data
    },
    setFaceSandBoxId(state, param) {
      state.faceSandBoxId = param
    },
    setStudentSandBoxId(state, param) {
      state.studentSandBoxId = param
    },
    setGuardianSandBoxId(state, param) {
      state.guardianSandBoxId = param
    },
    setClassCardModeCache(state, param) {
      state.classCardModeCache = param
    },
    selfDepts(state, param) {
      state.selfDepts = param
    },
    allowLeaveBackCertificate(state, param) {
      state.allowLeaveBackCertificate = param
    },
    activeTabIndex(state, param) {
      state.activeTabIndex = param
    },
    cacheObject(state, param) {
      state.cacheObject = param
    },
    applicationStatus(state, param) {
      state.applicationStatus = param
    },
    reasonType(state, param) {
      state.reasonType = param
    },
    dateNow(state, param) {
      state.dateNow = param
    },
    pageIsUpgraded(state, param) {
      state.pageIsUpgraded = param
    },
    semesterSetting(state, param) {
      state.semesterSetting = param || {
        schoolYear: '',
        termEndDimDay: '',
        termOrder: '',
        termStartDimDay: '',
        showTermDialog: false,
        beforeYearEndDate: '',
        canBeUpgraded: false
      }
      setItem('semesterSetting', state.semesterSetting)
    },
    semesterList(state, param) {
      state.semesterList = param
      setItem('semesterList', state.semesterList)
    },
    setIsCustomNotification(state, param) {
      state.isCustomNotification = param
    },
    setAddressParentNodeLists(state, param) {
      state.addressParentNodeLists = param
    },
    setAttendanceClassList(state, param) {
      state.attendanceClassList = param
    },
    setAttendanceSelectDetailNodesOrigin(state, param) {
      state.attendanceSelectDetailNodesOrigin = param
    },
    setGradeList(state, param) {
      state.gradeList = param
    },
    setAttendanceSelectDetailNodes(state, param) {
      state.attendanceSelectDetailNodes = param
    },
    // 保存token信息
    setToken(state, token) {
      state.token = token
      setItem('TOKEN', token)
    },
    setDormAdmin(state, isDormAdmin) {
      state.isDormAdmin = isDormAdmin
      setItem('isDormAdmin', isDormAdmin)
    },
    // 删除token信息
    removeToken(state) {
      state.token = null
      removeItem('TOKEN')
    },
    // 初始化标签
    setTags(state, tags) {
      state.tags = tags
      setItem('tags', tags)
    },
    // 初始化当前标签
    currentTagId(state, currentTagId) {
      state.currentTagId = currentTagId
      setItem('currentTagId', currentTagId)
    },
    // 初始化当前标签
    currentTagIdOld(state, currentTagIdOld) {
      state.currentTagIdOld = currentTagIdOld
      setItem('currentTagIdOld', currentTagIdOld)
    },
    // 切换当前校区（仅限管理器）
    changeCurrentCapmus(state, capmus) {
      state.token = state.token || getItem('TOKEN')
      state.currentCapmus = capmus
      // 保留当前角色选择的校区
      setLocalItem(`CURRENT_CAPMUS_${state.token.orgId}`, capmus)
      // 保存角色最后一次选择的校区
      setLocalItem(
        `ROLE_${state.currentRole}CURRENT_CAPMUS_${state.token.orgId}`,
        capmus
      )
      const { tpId = '' } = capmus || {}
      // 兼容旧业务
      setLocalItem('currentCapmusId', tpId)
    },
    // 保存过滤条件
    setFilterCondition(state, condition) {
      state.condition = condition
    },
    setCurrentTabId(state, currentTabId) {
      state.currentTabId = currentTabId
    },
    selectedClass(state, selectedClass) {
      state.selectedClass = selectedClass
    },
    // 考勤组名字
    saveGroupName(state, params) {
      state.attendanceGroup.attendanceGroupName = params
    },
    // 考勤日期
    attendanceDays(state, params) {
      state.attendanceGroup.attendanceDays = params
    },
    // 上下学时间段
    saveGroupDtoList(state, params) {
      state.attendanceGroup.timeSettingDtoList = params
    },
    // 成员id
    saveGroupMember(state, params) {
      state.attendanceGroup.members = params
    },
    // 已选人员
    memberCount(state, params) {
      state.attendanceGroup.memberCount = params
    },
    saveGroupMemberOld(state, params) {
      state.saveGroupMemberOld = params
    },
    // 保存部门
    saveGroupDepts(state, params) {
      state.attendanceGroup.depts = params
    },
    saveGroupDeptsOld(state, params) {
      state.saveGroupDeptsOld = params
    },
    // 保存设备IdattendanceDeviceIds
    saveGroupDeviceIds(state, params) {
      state.attendanceGroup.attendanceDeviceIds = params
    },
    // 是否开启家长代考勤guardianAttendance
    saveGroupGuardian(state, params) {
      state.attendanceGroup.guardianAttendance = params
    },
    // 是否开启上午不需要打卡
    saveGroupSchoolNotGoing(state, params) {
      state.attendanceGroup.noNeedCheckIn = params
    },
    // 是否开启下午不需要打卡
    saveGroupNotGoing(state, params) {
      state.attendanceGroup.noNeedCheckOut = params
    },
    // 考勤组id
    attendanceGroupId(state, params) {
      state.attendanceGroupId = params
    },
    // 保存考勤组日打卡详情初始化条件
    initFactor(state, params) {
      state.initFactor = params
    },
    // 学生考勤页面日期
    attendanceMainDate(state, params) {
      state.attendanceMain.date = params
    },
    // 学生考勤页面部门
    attendanceMainDepts(state, params) {
      state.attendanceMain.depts = params
    },
    // 学生考勤页面部门对象
    attendanceMainDept(state, params) {
      state.attendanceMain.dept = params
    },
    // 创建上下学时段
    attendanceCreateStage(state, params) {
      state.creatGoToSchoolStage = params
    },
    // 设置或保存单条上下学时间段
    attendanceCreateOneStage(state, params) {
      state.creatGoToSchoolOneStage = params
    },
    studentInfo(state, params) {
      state.studentInfo = params
    },
    // 保存家长选择孩子的序号
    studentNumber(state, params) {
      localStorage.setItem('studentNumber', params)
      state.studentNumber = params
    },
    // 日期获取的时间
    calendarTime(state, params) {
      state.calendarTime = params
    },
    // 获取老师班级信息
    teachInfo(state, params) {
      state.teachInfo = params
    },
    // 获取班主任id
    headmasterId(state, params) {
      state.headmasterId = params
    },
    // 月统计时间
    monthTime(state, params) {
      state.monthTime = params
    },
    // 判断是月统计还是打卡日历
    isCalendarForm(state, params) {
      state.isCalendarForm = params
    },
    // 设置考勤时段
    attendanceTimesList(state, params) {
      state.attendanceTimesList = params
    },
    // 当前使用的日期
    attendanceDate(state, params) {
      state.attendanceDate = params
    },
    // 预选时间
    primaryDate(state, params) {
      state.primaryDate = params
    },
    // 学生考勤提示
    attendanceTip(state, params) {
      state.attendanceTip = params
    },
    // 体验模式的title的显示隐藏
    expressModle(state, params) {
      state.expressModle = params
    },
    // 班主任下面的班级
    headmasterClass(state, params) {
      state.headmasterClass = params
    },
    defaultDateRange(state, params) {
      state.defaultDateRange = params
    },
    // 设置待设置数目
    settingNum(state, params) {
      state.settingNum = params
    },
    // 时段名称
    saveTimeName(state, params) {
      state.saveTimeName = params
    },
    // 宿管设备可用考勤 entranceDevice
    saveEntranceDevice(state, params) {
      state.entranceDevice[params[0]] = params[1]
    },
    // 到离校门禁不限制通行
    noLimitFlag(state, params) {
      state.noLimitFlag = params
    },
    // 到离校门禁限制通行时的通行次数
    passCount(state, params) {
      state.passCount = params
    },
    // 到离校门禁设备
    permitDevices(state, params) {
      state.permitDevices = params
    },
    // 班主任刷脸设备
    afterschoolHeaderMasterDevices(state, params) {
      state.afterschoolHeaderMasterDevices = params
    },
    // 配置id
    commonConfigId(state, params) {
      state.commonConfigId = params
    },
    // 请假冲突记录
    conflictLeaveList(state, conflictLeaveList) {
      state.conflictLeaveList = conflictLeaveList
    },
    // 请假数据
    leaveData(state, leaveData) {
      state.leaveData = leaveData
      setItem('leaveData', leaveData)
    },
    // 修改或者请假记录信息
    leaveRecord(state, leaveRecord) {
      state.leaveRecord = leaveRecord
    },
    noticeDtoList(state, noticeDtoList) {
      state.noticeDtoList = noticeDtoList
    },
    // 保存的投屏
    screenDetail(state, screenDetail) {
      state.screenDetail = screenDetail
    },
    deviceParams(state, deviceParams) {
      state.deviceParams = deviceParams
    },
    // 上下学类型
    inOutType(state, inOutType) {
      state.inOutType = inOutType
    },
    hasFlexLeaveDevice(state, hasFlexLeaveDevice) {
      state.hasFlexLeaveDevice = hasFlexLeaveDevice
    },
    clockPeriods(state, clockPeriods) {
      state.clockPeriods = clockPeriods
    },
    dormState(state, dormState) {
      state.dormState = dormState
    },
    dormDetailState(state, dormDetailState) {
      state.dormDetailState = dormDetailState
    },
    loadFromStore(state, loadFromStore) {
      state.loadFromStore = loadFromStore
    },
    isFromBack(state, isFromBack) {
      state.isFromBack = isFromBack
    },
    checkAttencer(state, checkAttencer) {
      state.checkAttencer = checkAttencer
    },
    attendanceMemberType(state, attendanceMemberType) {
      state.attendanceMemberType = attendanceMemberType
    },
    specialAttendanceDays(state, specialAttendanceDays) {
      state.specialAttendanceDays = specialAttendanceDays
    },
    specialNoAttendanceDays(state, specialNoAttendanceDays) {
      state.specialNoAttendanceDays = specialNoAttendanceDays
    },
    holidaysAttendance(state, holidaysAttendance) {
      state.holidaysAttendance = holidaysAttendance
    },
    sandboxId(state, sandboxId) {
      state.sandboxId = sandboxId
    },
    orgSandboxId(state, orgSandboxId) {
      setItem('orgSandboxId', orgSandboxId)
      setLocalItem('orgSandboxId', orgSandboxId)
      state.orgSandboxId = orgSandboxId
    },
    addressModifyMember(state, addressModifyMember) {
      state.addressModifyMember = addressModifyMember
    },
    isSandboxPrepared(state, isSandboxPrepared) {
      state.isSandboxPrepared = isSandboxPrepared
    },
    isSandboxCreated(state, isSandboxCreated) {
      state.isSandboxCreated = isSandboxCreated
    },
    isSandboxComplete(state, isSandboxComplete) {
      state.isSandboxComplete = isSandboxComplete
    },
    studentList(state, studentList) {
      state.studentList = studentList
    },
    studentDetail(state, studentDetail) {
      state.studentDetail = studentDetail
    },
    studentDetailCopy(state, studentDetail) {
      state.studentDetailCopy = { ...studentDetail }
    },
    currentAuditStatus(state, currentAuditStatus) {
      state.currentAuditStatus = currentAuditStatus
    },
    weekNow(state, weekNow) {
      state.weekNow = weekNow
    },
    weekList(state, weekList) {
      state.weekList = weekList
    },
    moralTimeType(state, moralTimeType) {
      state.moralTimeType = moralTimeType
    },
    isUseFaceInput(state, isUseFaceInput) {
      state.isUseFaceInput = isUseFaceInput
    },
    retryTimes(state, retryTimes) {
      state.retryTimes = retryTimes
    },
    classMoralClass(state, param) {
      state.classMoralClass = param
    },
    skuInfo(state, sku = {}) {
      setItem('sku', sku)
      state.skuInfo = sku
    },
    classcardDetail(state, param) {
      if (Array.isArray(param)) {
        state.classcardDetail[param[0]] = param[1]
      } else {
        state.classcardDetail = param
      }
    },
    qingtianDeviceDetail(state, param) {
      if (Array.isArray(param)) {
        state.qingtianDeviceDetail[param[0]] = param[1]
      } else {
        state.qingtianDeviceDetail = param
      }
    },
    classcardSource(state, param) {
      state.classcardSource = param
    },
    classDing(state, param) {
      state.classDing = param
    },
    studentHornor(state, param) {
      state.studentHornor = param
    },
    termSetting(state, param) {
      state.termSetting = param
    },
    setAttendanceQueryFilter(state, param) {
      state.attendanceQueryFilter = param
    },
    saveCycle(state, param) {
      state.saveCycle = param
    },
    pageList(state, param) {
      state.pageList = param
    },
    addCachedViews(state, route) {
      // 检查是否存在
      let index = state.cachedViews.findIndex(item => item.name === route.name)
      if (index < 0) {
        state.cachedViews = state.cachedViews.concat(route)
      } else {
        state.cachedViews = state.cachedViews.slice(0, index + 1)
      }
    },
    deleteCachedViewsByPath(state, name) {
      if (state.cachedViews.length) {
        state.cachedViews = state.cachedViews.reduce((views, route) => {
          return views.concat(route.name === name ? [] : route)
        }, [])
      }
    },
    clearCachedViews(state, views) {
      state.cachedViews = views
    },
    classEvaluationTab(state, param) {
      state.classEvaluationTab = param
    },
    classEvaluationDingId(state, param) {
      state.classEvaluationDingId = param
    },
    platformSource(state, param) {
      state.platformSource = param
    },
    specifyTeacher(
      state,
      {
        isScheduleTeacher,
        isClassTeacher,
        isMeTeacher,
        isCETeacher,
        isCampusHeadmaster
      } = {}
    ) {
      state.isScheduleTeacher = isScheduleTeacher
      state.isClassTeacher = isClassTeacher
      state.isMeTeacher = isMeTeacher
      state.isCETeacher = isCETeacher
      state.isCampusHeadmaster = isCampusHeadmaster
    },
    classcardTemplate(state, classcardTemplate) {
      state.classcardTemplate = classcardTemplate
    },
    dishSegmentList(state, param) {
      state.dishSegmentList = param
    },
    dishDetail(state, param) {
      state.dishDetail = param
    },
    selectedDish(state, param) {
      state.selectedDish = param
    },
    dishFilter(state, param) {
      state.dishFilter = param
    },
    isEditDish(state, param) {
      state.isEditDish = param
    },
    mealType(state, param) {
      state.mealType = param
    },
    dashActiveIndex(state, param) {
      state.dashActiveIndex = param
    },
    dishModifyType(state, param) {
      state.dishModifyType = param
    },
    commonDishesClassifyObj(state, param) {
      state.commonDishesClassifyObj = param
    },
    changeStatus(state, param) {
      state.substituteStatus = param
    },
    setMoralTimePickerData(state, pickerValue) {
      state.moralTimePickerMap = {
        ...pickerValue
      }
      setItem(MORAL_TIME_PICKER_TYPE, state.moralTimePickerMap)
    },
    setDeviceManageType(state, deviceType) {
      state.deviceManageType = deviceType
    },
    setLeaveTypeObj(state, leaveTypeObj) {
      state.leaveTypeObj = leaveTypeObj
    },
    setLeaveStatisticsDate(state, leaveStatisticsDate) {
      state.leaveStatisticsDate = leaveStatisticsDate
    },
    setSpanHour(state, hour) {
      state.attendanceSpanHour = hour
    },
    setRouteForTabbar(state, route) {
      state.routeForTabbar = route
    },
    setVehicleVersion(state, version) {
      state.vehicleApiVersion = version
      state.vehicleVersionUpdatedAt = Date.now()
    },
    setBehaviorDate(state, param) {
      state.behaviorDate = param
    },
    setBehaviorDateRange(state, param) {
      state.behaviorDateRange = param
    },
    setBehaviorClass(state, param) {
      state.behaviorClass = param
    },
    setNoticeRoleList(state, param) {
      state.noticeRoleList = param
    },
    // 学生签到：设置选中的班级卡片
    setSignInClassItem(state, payload) {
      state.signInClassItem = payload
    },
    setOrderInfo(state, payload) {
      state.orderInfo = payload
    }
  },
  actions: {
    ...moduleRole.actions,
    async leaveBackConfigGet({ commit, getters }, params) {
      if (getters.allowLeaveBackCertificate === 0) {
        const res = await API.leaveBackConfigGet({
          campusId: (getters.currentCapmus || {}).tpId || '',
          operUserRoleTypes: getters.currentRole
        })
        commit('allowLeaveBackCertificate', !!(res || {}).submitSwitch || false)
      }
    },
    // 检测学年学期设置
    handlerCheckSemester({ commit, getters }, params) {
      commit('semesterSetting', null)
      const defalutParams = {
        campusId:
          (getters.currentCapmus || {}).tpId ||
          getItem('currentCapmusId') ||
          '',
        operUserDingId: (getters.token || {}).userid || '',
        operUserName: (getters.token || {}).userName || '',
        operUserRoleTypes: getters.currentRole,
        orgId: (getters.token || {}).orgId,
        ...params
      }
      if (!defalutParams.campusId) {
        return
      }
      return new Promise((resolve, reject) => {
        API.getSchoolYearTermList({
          ...defalutParams
        })
          .then(async res => {
            let data = ((res && res[0] && res) || []).filter(
              v => v.schoolTermStartDimDay
            )
            commit('semesterList', data)
            let _date = timeFormat(new Date(), 'YYYYMMDD')
            let currentDate = timeFormat(new Date(), 'YYYY-MM-DD')
            const _month = new Date(currentDate).getMonth() + 1
            const fullYear = new Date(currentDate).getFullYear()
            let _schoolYear =
              (res && res[0] && res[0].schoolYear) ||
              (_month > 8 ? fullYear : fullYear - 1) // 默认学年

            let _termOrder = getTermOrder(currentDate, _schoolYear) // 默认学期
            let _showDialog = false
            let _isYearUpdate = false
            let _beforeYearEndDate = null
            let _termStartDimDay = ''
            let _termEndDimDay = ''
            if (!data.length) {
              console.log(`当前不在学年学期范围内或未设置学年学期`)
              _showDialog = true
            } else if (data.length === 1) {
              _termOrder = data[0].schoolTermOrder
              _termStartDimDay = data[0].schoolTermStartDimDay
              _termEndDimDay = data[0].schoolTermEndDimDay
            } else if (data.length === 2) {
              if (data[0].schoolTermEndDimDay >= _date) {
                _termOrder = 1
                _termStartDimDay = data[0].schoolTermStartDimDay
                _termEndDimDay = data[0].schoolTermEndDimDay
              } else {
                _termOrder = 2
                _termStartDimDay = data[1].schoolTermStartDimDay
                _termEndDimDay = data[1].schoolTermEndDimDay
              }
            }
            let _canBeUpgraded = false
            // 只有管理员才需要获取上一年结束日期和是否可升级学年
            if (getters.curIsAdmin) {
              try {
                const result = await API.getYearEndDate({
                  ...defalutParams,
                  schoolYear: _schoolYear - 1 // 上一年的结束日期
                })
                if (
                  (result && result.result && result.result !== '0') ||
                  result === null
                ) {
                  _beforeYearEndDate = ''
                } else {
                  _beforeYearEndDate = dateToTime(result)
                }
              } catch (error) {
                _beforeYearEndDate = ''
                console.log(error)
              }
              // const case1 = !firstEnd && !secondEnd && termOrder === 2 // 未设置学年学期并且处于 2.1 - 8.31 时间段
              // const case2 = firstEnd && new Date() > firstEnd // 设置第一学期且第一学期已结束
              // const case3 = secondEnd // 设置了第二学期
              _canBeUpgraded =
                (!data.length && _termOrder === 2) ||
                (data[0] &&
                  data[0].schoolTermOrder === 1 &&
                  _date > data[0].schoolTermEndDimDay) ||
                (data[0] && data[0].schoolTermOrder === 2) ||
                data.length === 2
              if (_canBeUpgraded) {
                try {
                  const isYearRes = await API.getIsYearUpdate({
                    ...defalutParams,
                    schoolYear: _schoolYear // 当前学年是否可升级
                  })
                  if (
                    (isYearRes &&
                      isYearRes.result &&
                      isYearRes.result !== '0') ||
                    isYearRes === null
                  ) {
                    _isYearUpdate = ''
                  } else {
                    _isYearUpdate = isYearRes
                  }
                } catch (error) {
                  _isYearUpdate = ''
                  console.log(error)
                }
              }
            }
            let firstStart = ''
            let firstEnd = ''
            let secondStart = ''
            let secondEnd = ''
            data.map(v => {
              if (v.schoolTermOrder === 1) {
                firstStart = v.schoolTermStartDimDay + ''
                firstEnd = v.schoolTermEndDimDay + ''
              } else {
                secondStart = v.schoolTermStartDimDay + ''
                secondEnd = v.schoolTermEndDimDay + ''
              }
            })
            commit('semesterSetting', {
              schoolYear: _schoolYear,
              termOrder: _termOrder,
              termStartDimDay: _termStartDimDay,
              termEndDimDay: _termEndDimDay,
              showTermDialog: _showDialog,
              beforeYearEndDate: _beforeYearEndDate,
              canBeUpgraded: _canBeUpgraded && _isYearUpdate, // 综合判断当前学年是否可升级
              firstStart,
              firstEnd,
              secondStart,
              secondEnd
            })
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    handlerUpdateSemesterYear({ getters, commit }) {
      return new Promise((resolve, reject) => {
        API.getYearUpdate({
          campusId: (getters.currentCapmus || {}).tpId || '',
          operUserDingId: getters.token.userid || '',
          operUserName: getters.token.userName || '',
          operUserRoleTypes: getters.currentRole,
          orgId: getters.token.orgId,
          schoolYear: (getters.semesterSetting || {}).schoolYear
        })
          .then(res => {
            if (res && res.result && +res.result !== 0) {
              reject(res)
            } else {
              commit('semesterSetting', null)
              commit('semesterList', null)
              removeItem('semesterSetting')
              removeItem('semesterList')
              commit('pageIsUpgraded', true)
              resolve(res)
            }
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      })
    },
    /**
     * 获取自然周，不与学年学期挂钩
     * @param {*} params
     * @returns
     */
    commitNormalWeekList({ getters, commit }, params) {
      return new Promise((resolve, reject) => {
        API.getFamilyNaturalWeek({
          campusId: params.campusId || '',
          operUserRoleTypes: `${getters.currentRole}`
        })
          .then(res => {
            let _weekList = []
            ;(res || []).forEach((item, index) => {
              const startDay = +timeFormat(
                new Date(item.familyCallStartDate),
                'YYYYMMDD'
              )
              const endDay = +timeFormat(
                new Date(item.familyCallEndDate),
                'YYYYMMDD'
              )
              _weekList.push({
                weekId: index + 1,
                startDay,
                endDay,
                name: `第 ${index + 1} 周（${timeFormat(
                  timeStrToDate(`${startDay}`),
                  'MM.DD'
                )} ~ ${timeFormat(timeStrToDate(`${endDay}`), 'MM.DD')}）`
              })
            })
            const { startDay, endDay, name } = _weekList[_weekList.length - 1]
            resolve({
              weekList: _weekList,
              filter: {
                weekId: _weekList.length - 1,
                startDay,
                endDay,
                weekStr: name
              }
            })
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    commitFetchWeekList({ getters, commit }, params) {
      return new Promise((resolve, reject) => {
        const { schoolYear, termOrder, termEndDimDay, termStartDimDay } =
          getters.semesterSetting || {}
        if (!schoolYear) {
          return
        }
        API.getYearTeachWeek({
          campusId: params.campusId || '',
          operUserRoleTypes: `${getters.currentRole}`,
          schoolYear
        })
          .then(res => {
            // 筛选当前学期的教学周
            const { schoolTermTeachWeekRespList } = (res || []).filter(
              item => item.schoolTermOrder === termOrder
            )[0]
            let _weekList = schoolTermTeachWeekRespList.reduce(
              (list, item) =>
                list.concat({
                  weekId: item.teachWeekId,
                  startDay: item.teachWeekStartDimDay,
                  endDay: item.teachWeekEndDimDay,
                  name: `第 ${item.teachWeekId} 周（${timeFormat(
                    timeStrToDate(`${item.teachWeekStartDimDay}`),
                    'MM.DD'
                  )} ~ ${timeFormat(
                    timeStrToDate(`${item.teachWeekEndDimDay}`),
                    'MM.DD'
                  )}）`
                }),
              []
            )
            // 获取当前对应周信息
            const day = +timeFormat(new Date(), 'YYYYMMDD')
            let matchedWeek = null
            // 当前日期不在当前学年学期的开始结束范围内 如果小于开始日期按照第一周 如果大于最后一周就按照最后一周
            if (day < termStartDimDay) {
              matchedWeek = _weekList[0]
            } else if (day > termEndDimDay) {
              matchedWeek = _weekList[_weekList.length - 1]
            } else {
              matchedWeek = _weekList.filter(
                item => item.startDay <= day && item.endDay >= day
              )[0]
            }
            // 获取当前周对应的周日日期
            const currDate = new Date()
            const weekday = currDate.getDay()
            currDate.setDate(
              currDate.getDate() + (weekday === 0 ? 0 : 7 - weekday)
            )
            const dimDay = +timeFormat(currDate, 'YYYYMMDD')
            let limitWeek = _weekList.filter(item => item.endDay <= dimDay)
            // 学期未开始，显示全部
            if (day < termStartDimDay) {
              limitWeek = _weekList
            }
            const { weekId, startDay, endDay, name } = matchedWeek
            resolve({
              limitWeek,
              weekList: _weekList,
              filter: { weekId, startDay, endDay, weekStr: name }
            })
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    guardianInitCampus({ getters, commit }) {
      return new Promise((resolve, reject) => {
        if (
          +getters.currentRole !== LEAVE_ROLE.guardian ||
          !(getters.studentList || []).length
        ) {
          resolve()
          return
        }
        const getCombinedCampus = () => {
          let _campus = (getters.teacherCampus || []).concat(
            getters.meTeacherCampus,
            getters.ceTeacherCampus,
            getters.scheduleTeacherCampus
          )
          let _campusId = {}
          let _campusList = []
          _campus.forEach(item => {
            if (!_campusId[item.tpId]) {
              _campusId[item.tpId] = 1
              _campusList.push(item)
            }
          })
          return _campusList
        }
        const getCampusName = () => {
          let current = getters.classCampus
            .concat(
              getters.campusList || [],
              getters.dormList || [],
              getters.dormList || [],
              getCombinedCampus()
            )
            .find(v => v.tpId === campusId)
          return (current || {}).name || ''
        }
        const { memberId, campusId, classic, deptId } =
          getters.studentList.find(v => v.memberId === getters.studentNumber) ||
          getters.studentList[0]

        commit('changeCurrentCapmus', {
          classic: classic,
          deptId: deptId,
          name: getCampusName(),
          tpId: campusId
        })
        commit('studentNumber', memberId)
        resolve()
      })
    }
  },
  modules: {
    expireSku,
    security
  }
})
